import { makeObservable, observable, action } from 'mobx';
import { lang } from '@lang/interfaces/lang';
import { langs } from '@lang/enums/langs';
import Dictionary from '@lang/Dictionary';
import { RootStore } from './Root.store';

export type languageMap = {
    [key in langs]: string;
};

export default class LanguageStore {
    private dictionary: Dictionary;

    @observable
    public lang: lang;

    @observable
    public languages: lang[] = Object.values(langs);

    @observable
    public langMap: languageMap = {
        ru: 'Русский',
        en: 'English',
    };

    constructor(private rootStore: RootStore) {
        this.setDefault();
        makeObservable(this);
    }

    @action
    _getLang(lang: string): lang {
        if (this.languages.includes(lang as lang)) {
            return lang as lang;
        } else {
            return langs.ru;
        }
    }

    @action
    _setDictionary(lang: lang) {
        try {
            this.dictionary = new Dictionary(lang);
            this.lang = lang;
        } catch (e) {
            console.error(e);
        }
    }

    @action
    setDefault() {
        const savedLang = localStorage.getItem('lang');
        const _lang = savedLang ? savedLang : langs.ru;
        const lang = this._getLang(_lang);
        this._setDictionary(lang);
    }

    @action
    setLanguage(lang: string) {
        const _lang = this._getLang(lang);
        if (lang === _lang) {
            this._setDictionary(_lang);
            localStorage.setItem('lang', _lang);
        }
    }

    @action
    getWord(word: string) {
        return this.dictionary.getWord(word);
    }

    @action
    getKey(word: string) {
        return this.dictionary.getKey(word);
    }
}
